var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-common-spacer"},[_c('div',{staticClass:"plugin-common-spacer__desktop",style:(_vm.desktopStyles)}),_c('div',{staticClass:"plugin-common-spacer__mobile",style:(_vm.mobileStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }